import { inject, Service } from "@angular/core"
import { Observable } from "rxjs"
import { HttpClient } from "@angular/common/http"
import { Award, PagedAward, CreateAward, ModifyObject } from "../models"
import { environment } from "src/environments/environment"

export interface ColumnFilter {
    field: string
    value: string
    matchMode: string
}

export interface GetAwardPagedParams {
    search?: string
    sortField?: string
    sortDescending?: boolean
    page: number
    pageSize: number
    columnFilters?: ColumnFilter[]
}

@Service({ autoProvided: false })
export class AwardsService {
    private _http = inject(HttpClient)
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.awards

    Get(): Observable<Award[]> {
        return this._http.get<Award[]>(this._apiUrl)
    }

    GetOne(masterId: string): Observable<Award> {
        return this._http.get<Award>(this.ByMasterIdUrl(masterId))
    }

    GetByMasterId(masterId: string): Observable<Award> {
        return this._http.get<Award>(this.ByMasterIdUrl(masterId))
    }
    ByMasterIdUrl(masterId: string): string {
        return `${this._apiUrl}/${masterId}`
    }

    GetPaged(params: GetAwardPagedParams): Observable<PagedAward> {
        const request = this.PagedRequest(params)
        return this._http.get<PagedAward>(request.url, { params: request.params })
    }
    PagedRequest(params: GetAwardPagedParams): { url: string; params: Record<string, string> } {
        const httpParams: Record<string, string> = {
            page: params.page.toString(),
            pageSize: params.pageSize.toString(),
        }
        if (params.search) httpParams["search"] = params.search
        if (params.sortField) httpParams["sortField"] = params.sortField
        if (params.sortDescending !== undefined) httpParams["sortDescending"] = params.sortDescending.toString()
        if (params.columnFilters?.length) httpParams["columnFilters"] = JSON.stringify(params.columnFilters)

        return { url: this._apiUrl + "/paged", params: httpParams }
    }

    Create(createAward: CreateAward): Observable<Award> {
        const { amount, ...payload } = createAward
        return this._http.post<Award>(this._apiUrl, payload)
    }

    Modify(masterId: string, data: ModifyObject): Observable<any> {
        return this._http.patch(this.ByMasterIdUrl(masterId), data)
    }

    Delete(masterId: string): Observable<string> {
        return this._http.delete<string>(this.ByMasterIdUrl(masterId))
    }
}
